module.exports = __webpack_public_path__ + "img/风机检测.49c7ab64.jpg";